Ext.define('SA.EditModelLocations', {
    constructor(model) {
        this.model = model;
    },

    clear() {
        this.getSelected().forEach(location => this.model.removeLocation(location));
        this.model.save();
    },

    filterProjectLocations(filter) {
        return this.model.getProject().getLocations().filter(id => filter(id));
    },

    getSelected() {
        return this.model.getLocations();
    },

    getSupported() {
        return this.filterProjectLocations(id => this.supports(id));
    },

    getUnsupported() {
        return this.filterProjectLocations(id => !this.supports(id));
    },

    isSelected(location) {
        if (location === null) {
            return this.getSelected().length === 0;
        }

        return this.getSelected().includes(location);
    },

    select(locations) {
        this.model.addLocations(locations);
        this.model.save();
    },

    supports(location) {
        return this.model.supportsLocation(location);
    },

    toggle(location, toggle) {
        toggle ? this.model.addLocation(location) : this.model.removeLocation(location);
        this.model.save();
    }
});